import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICancellationPolicyDisplayData } from 'model/view-models/results/product-card/price-display-data.interface';

@Component({
  selector: 'usb-booking-actions',
  template: `
              <div *ngIf="categoryId !== 5" class="d-flex flex-column mt-2 ml-2">
                <p class="mb-0 rubik-regular-12pt" style="font-weight: 500"
                      [ngStyle]="{ 'color': '#5bca90' }"
                      aria-hidden="true">
                  {{cancellationPolicyData?.displayText}}
                </p>
                <p class="mb-0 rubik-regular-12pt"
                      aria-hidden="true">
                    <ng-container *ngIf="cancellationPolicyData?.isRefundable; else nonRefundable">
                      <ng-container *ngIf="cancellationPolicyData?.refundableUntil">
                          Hasta {{ cancellationPolicyData?.refundableUntil | date:'dd/MM/yyyy' }}
                      </ng-container>
                      <ng-container *ngIf="cancellationPolicyData?.refundableUntil === null || cancellationPolicyData?.refundableUntil === ''">
                          N/A
                      </ng-container>
                    </ng-container>
                    <ng-template #nonRefundable>
                      100% costo
                    </ng-template>
                </p>
              </div>

             <div class="d-flex flex-column" style="margin-bottom: 10px; height: 100%;margin-top:30px;margin-left: -6px">
                <button type="button" class="d-flex align-items-center justify-content-center" (click)="openModal()"
                  style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 600; width: 135px; height: 32px; line-height: 1; padding-top: 0px; border-radius: 4px; border: none; cursor: pointer"
                  [style.color]="'black' || '#ffffff'"
                  [style.background-color]="clientsSettingAppBooking?.clients_setting_global?.color_main_1 || '#000000'">
                  <p class="mb-0">Agregar</p>
                </button>
            </div>
            `
            ,
  styleUrls: ['../base-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingActionsComponent implements OnInit {

  @Input() readonly clientsSettingAppBooking;
  @Input() readonly stylePathPrice;
  @Input() readonly cancellationPolicyData!: Readonly<ICancellationPolicyDisplayData>;
  @Input() readonly categoryId;
  @Output() openModalEmit = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  openModal(): void {
    this.openModalEmit.emit();
  }


}
